import { Injectable } from '@angular/core';
import { InMemoryDbService } from 'angular-in-memory-web-api';

@Injectable({
  providedIn: 'root'
})
export class FormData implements InMemoryDbService {
  constructor() {}

  createDb() {
    const test = {
      forms: {
        formMap: {
          inputElementList: [
            {
              parent: 'row',
              inputs: [
                {
                  elementName: 'text-input',
                  idName: 'input_text_one',
                  className: 'form-control',
                  formControlName: 'firstName',
                  name: 'first name',
                  maxLength: '100',
                  type: 'input',
                  value: '',
                  label: 'First Name',
                  readonly: false,
                  autocomplete: 'off',
                  isDisabled: true,
                  placeholder: 'First Name',
                  onFocus: 'dummyFunction',
                  onClick: 'dummyFunction',
                  onEnter: 'dummyFunction',
                  onBlur: 'changeValidate',
                  column: 'col-12',
                  validation: [
                    {
                      name: 'required'
                    }
                  ]
                }
              ]
            },
            {
              parent: 'row my-2',
              inputs: [
                {
                  elementName: 'text-input',
                  idName: 'input_text_two',
                  className: 'form-control',
                  name: 'lastname',
                  formControlName: 'lastName',
                  value: '',
                  maxLength: '100',
                  type: 'input',
                  label: 'Last Name',
                  readonly: false,
                  autocomplete: 'off',
                  isDisabled: false,
                  placeholder: 'Last Name',
                  onFocus: 'dummyFunction',
                  onClick: 'dummyFunction',
                  onBlur: 'changeValidate',
                  onEnter: 'dummyFunction',
                  column: 'col-12',
                  validation: [
                    {
                      name: 'required'
                    }
                  ]
                }
              ]
            },
            {
              parent: 'row my-2',
              inputs: [
                {
                  elementName: 'text-input',
                  idName: 'email_input',
                  className: 'form-control',
                  name: 'email',
                  formControlName: 'email',
                  value: '',
                  maxLength: '100',
                  type: 'email',
                  label: 'Email',
                  readonly: false,
                  autocomplete: 'off',
                  isDisabled: false,
                  placeholder: 'Email',
                  onFocus: 'dummyFunction',
                  onClick: 'dummyFunction',
                  onBlur: 'changeValidate',
                  onEnter: 'dummyFunction',
                  column: 'col-12',
                  validation: [
                    {
                      name: 'required'
                    },
                    {
                      name: 'email'
                    }
                  ]
                }
              ]
            },
            {
              parent: 'row my-2',
              inputs: [
                {
                  elementName: 'select-list',
                  idName: 'select_items',
                  className: 'form-control',
                  name: 'select list',
                  formControlName: 'selectItem',
                  label: 'Select Item',
                  placeholder: 'Select an Item',
                  type: 'input',
                  onFocus: 'dummyFunction',
                  onClick: 'dummyFunction',
                  onBlur: 'changeValidate',
                  value: '',
                  readonly: false,
                  innerelements: [
                    {
                      value: 'item-one',
                      label: 'item one'
                    },
                    {
                      value: 'item-two',
                      label: 'item two'
                    },
                    {
                      value: 'item-three',
                      label: 'item three'
                    }
                  ],
                  column: 'col-12',
                  validation: [
                    {
                      name: 'required'
                    }
                  ]
                }
              ]
            },
            {
              parent: 'row my-2',
              inputs: [
                {
                  elementName: 'numberInput',
                  idName: 'phone_number',
                  className: 'form-control',
                  name: 'phoneNumber',
                  placeholder: 'Enter Your phone number',
                  value: '',
                  formControlName: 'numberInput',
                  label: 'Phone number',
                  onFocus: 'focusFunction',
                  onClick: 'dummyFunction',
                  onBlur: 'changeValidate',
                  onEnter: 'validatingForm',
                  type: 'input',
                  readonly: false,
                  pattern: 'tel',
                  column: 'col-12',
                  maxlength: '13',
                  validation: [
                    {
                      name: 'required'
                    },
                    {
                      name: 'mobile'
                    }
                  ]
                }
              ]
            },
            {
              parent: 'row my-2',
              inputs: [
                {
                  elementName: 'radio-button',
                  idName: '',
                  className: 'column6',
                  name: 'radio-elm',
                  label: 'select raion elm',
                  formControlName: 'radioBtn',
                  placeholder: 'Year',
                  type: 'input',
                  onFocus: 'dummyFunction',
                  onClick: 'dummyFunction',
                  onBlur: 'changeValidate',
                  onKeyUp: 'dummyFunction',
                  column: 'col-12',
                  value: '1',
                  innerelements: [
                    {
                      id: 'radiobutton1',
                      label: 'One Year',
                      value: '1'
                    },
                    {
                      id: 'radiobutton2',
                      label: 'Two Years',
                      value: '2'
                    },
                    {
                      id: 'radiobutton3',
                      label: 'three Years',
                      value: '3'
                    }
                  ],
                  validation: [
                    {
                      name: 'required'
                    }
                  ]
                }
              ]
            },
            {
              parent: 'row my-2',
              inputs: [
                {
                  elementName: 'checkbox',
                  idName: 'checkbox_feild',
                  className: '',
                  formControlName: 'checkboxInput',
                  name: 'checkbox_feild',
                  value: true,
                  checked: true,
                  label: 'Checkbox',
                  onFocus: 'focusFunction',
                  onClick: 'dummyFunction',
                  onBlur: 'dummyFunction',
                  onEnter: 'validatingForm',
                  type: 'input',
                  column: 'col-md-12',
                  is_rejection: true,
                  validation: [
                    {
                      name: 'required'
                    }
                  ]
                }
              ]
            },
            {
              parent: 'row my-2',
              inputs: [
                {
                  elementName: 'date-picker',
                  idName: 'loss_date',
                  className: 'form-control',
                  name: 'Loss date',
                  formControlName: 'datePickerInput',
                  tooltip: '',
                  placeholder: 'Select Loss Date',
                  type: 'input',
                  label: 'Loss Date',
                  onFocus: 'dummyFunction',
                  dateFormat: 'DD-MM-YYYY',
                  isAnimated: true,
                  inAdaptive: true,
                  hideOnScroll: false,
                  returnFocusToInput: false,
                  selectDateFromOtherMonth: false,
                  outSideClick: true,
                  colorTheme: 'theme-dark-blue',
                  onClick: 'dummyFunction',
                  onBlur: 'dummyFunction',
                  onKeyUp: 'changeValidate',
                  value: '',
                  column: 'col-12 ',
                  validation: [
                    {
                      name: 'required'
                    },
                    {
                      name: 'date'
                    }
                  ]
                }
              ]
            },
            {
              parent: 'row my-2',
              inputs: [
                {
                  elementName: 'date-picker',
                  idName: 'gain_date',
                  className: 'form-control',
                  name: 'Gain date',
                  formControlName: 'dateGainPickerInput',
                  tooltip: '',
                  placeholder: 'Select gain Date',
                  type: 'input',
                  label: 'Gain Date',
                  onFocus: 'dummyFunction',
                  dateFormat: 'DD-MM-YYYY',
                  isAnimated: true,
                  inAdaptive: true,
                  hideOnScroll: false,
                  returnFocusToInput: false,
                  selectDateFromOtherMonth: false,
                  outSideClick: true,
                  colorTheme: 'theme-dark-blue',
                  onClick: 'dummyFunction',
                  onBlur: 'dummyFunction',
                  onKeyUp: 'changeValidate',
                  value: '',
                  column: 'col-12 ',
                  validation: [
                    {
                      name: 'required'
                    },
                    {
                      name: 'date'
                    }
                  ]
                }
              ]
            },
            {
              parent: 'row my-2',
              inputs: [
                {
                  elementName: 'text-area',
                  idName: 'textarea_input',
                  className: 'form-control',
                  formControlName: 'textAreaControl',
                  name: 'textarea_input',
                  maxLength: '100',
                  type: 'input',
                  value: '',
                  label: 'Textarea',
                  readonly: false,
                  rows: 5,
                  cols: 20,
                  isDisabled: true,
                  placeholder: 'please enter description',
                  onFocus: 'dummyFunction',
                  onClick: 'dummyFunction',
                  onEnter: 'dummyFunction',
                  onBlur: 'changeValidate',
                  column: 'col-12',
                  validation: [
                    {
                      name: 'required'
                    }
                  ]
                }
              ]
            },
            {
              parent: 'row my-2',
              inputs: [
                {
                  elementName: 'radio-switch',
                  idName: 'radio_switch_one',
                  className: '',
                  name: 'radio_switch_one',
                  formControlName: 'radioSwitchBtn',
                  value: true,
                  checked: true,
                  label: {
                    isActive: 'yes',
                    isInActive: 'no'
                  },
                  onFocus: 'focusFunction',
                  onClick: 'dummyFunction',
                  onBlur: 'dummyFunction',
                  onEnter: 'validatingForm',
                  type: 'input',
                  column: 'col-md-12',
                  validation: []
                }
              ]
            },
            {
              parent: 'row my-2',
              inputs: [
                {
                  elementName: 'primary-btn',
                  idName: '',
                  className: 'btn-secondary',
                  name: '',
                  label: 'Submit',
                  placeholder: '',
                  type: 'button',
                  onFocus: 'dummyFunction',
                  onClick: 'validatingForm',
                  onBlur: 'dummyFunction',
                  column: 'col-12',
                  hasPressEnter: false
                }
              ]
            }
          ]
        }
      }
    };
    return { test };
  }
}
